import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Post} from "../models/post.model";
import {Credentials} from "../models/credentials";
import {CommentModel} from "../models/comment.model";
import { DeleteResponse } from "../models/deletemodelResponse";
import {LocalDataService} from "../services/local-data.service";
import {CommentService} from "../services/comment.service";
import {server} from "../services/index.path";
import { ObservablepostService } from '../services/observablepost.service';
import { SharedinfoService } from '../nservices/sharedinfo.service';
import { CredentialsService } from '../nservices/login/credentials.service';
import { PublicationModel } from '../nmodels/publication.model';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-details-publication',
  templateUrl: './details-publication.component.html',
  styleUrls: ['./details-publication.component.css']
})
export class DetailsPublicationComponent implements OnInit {

  public whitoutPoints = [{
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
          "visibility": "off"
        }]
      }
    ];

    credentials?:Credentials;
    post?:Post;
    username?:string;
    date?:string;
    time?:string;
    source = server;
    comment?:string;

    publication:PublicationModel;
    latitude:number;
    longitude:number;
    comments:CommentModel[];
    viewpost:any;

    constructor(private _router: Router,private _credentialsS:CredentialsService,
                private _commentS:CommentService,private _sharedinfoS:SharedinfoService,public toastr: ToastsManager, vcr: ViewContainerRef) {
                  this.toastr.setRootViewContainerRef(vcr);
      if(!this._credentialsS.getCredentials()){
        this._router.navigate(['login']);
      }
      else if(this._credentialsS.getCredentials() && !this._sharedinfoS.getasParamPublication()){
        this._router.navigate(['home']);
      }
      else if(this._credentialsS.getCredentials() && this._sharedinfoS.getasParamPublication()){
        this.publication = this._sharedinfoS.getasParamPublication();
        this.fillRequirements();
        this._sharedinfoS.setasParamPublication(null);
      }

    }

  ngOnInit() {
  }
  makeComment(){
    console.log("id del post para comentar: "+this.publication.id);
    this._commentS.storeComment(this.publication.id,this.comment).subscribe(()=>{
      this.getComments();
      this.comment = "";
    })
  }
  /**
   * recibe el indice del arreglo de comentarios
   * @param comment_idx 
   */
  deleteComment(comment_idx:number){
    if(confirm("¿Estas seguro de elimar este comentario?")){
      this._commentS.deleteComment(this.comments[comment_idx].id)
          .subscribe(()=> {
            this.toastr.success('se elimino el comentario', 'Listo! ');
            // alert("Listo!");
            this.getComments();
          });
    }
  }
  private getComments(){
    this._commentS.getByPost(this.publication.id)
           .subscribe(resp => {
             this.comments = resp;
             this.comments.reverse();
           })
  }

  private fillRequirements(){
    this.latitude = Number(this.publication.latitude_event);
    this.longitude = Number(this.publication.longitude_event);
    this.getComments();
  }

  orderedComments(){
    this.comments.reverse();
  }

  backHome(){
    this._router.navigate(['home'],{ queryParams: { toback: 1 } });
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/details-publication/details-publication.component.ts